/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Workflow_2Inputs */

const en_visa_eb5_workflow_2 = /** @type {(inputs: Visa_Eb5_Workflow_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceed through the appropriate immigrant visa or adjustment process if the petition is approved.`)
};

const pt_visa_eb5_workflow_2 = /** @type {(inputs: Visa_Eb5_Workflow_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançar pelo processo apropriado de visto de imigrante ou ajuste se a petição for aprovada.`)
};

const es_visa_eb5_workflow_2 = /** @type {(inputs: Visa_Eb5_Workflow_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar por el proceso apropiado de visa de inmigrante o ajuste si la petición es aprobada.`)
};

/**
* | output |
* | --- |
* | "Proceed through the appropriate immigrant visa or adjustment process if the petition is approved." |
*
* @param {Visa_Eb5_Workflow_2Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_workflow_2 = /** @type {((inputs?: Visa_Eb5_Workflow_2Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Workflow_2Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_workflow_2(inputs)
	if (locale === "es") return es_visa_eb5_workflow_2(inputs)
	return en_visa_eb5_workflow_2(inputs)
});